import { Button } from "@mui/material";
import React, { useEffect, useState } from "react";
import { IImovelFocus } from "../../../Pages/Cartorio_Pages/App_Pages/ImovelFocus";
import theme from "../../../Styles/theme";
import { ModalObservacoes } from "./ModalObservacoes";
import { Container } from "./styles";
import { Edit as EditIcon } from "@mui/icons-material";
interface Props {
  imovel: IImovelFocus;
  handleSetImovel(im: IImovelFocus): void;
  editavel: boolean;
}

export function Observacoes({ imovel, handleSetImovel, editavel }: Props) {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <>
      <Container
        // onClick={() => setModalOpen(true)}
        id="textarea"
        interactive={editavel}
        style={{
          whiteSpace: "pre-line",

          border: "1px solid rgba(224, 224, 224, 1)",
          fontSize: "14px",
          background: theme.colors.light,
        }}
      >
        {imovel.OBSERVACOES ? imovel.OBSERVACOES : "Observações..."}
      </Container>
      {editavel && (
        <div
          style={{ width: "100%", display: "flex", justifyContent: "center" }}
        >
          <br />
          <Button
            variant="contained"
            startIcon={<EditIcon />}
            onClick={() => {
              setModalOpen(true);
            }}
          >
            {" "}
            Editar Observações
          </Button>
        </div>
      )}
      {editavel ? (
        <ModalObservacoes
          open={modalOpen}
          onClose={() => setModalOpen(false)}
          imovel={imovel}
          handleSetImovel={handleSetImovel}
        />
      ) : (
        ""
      )}
    </>
  );
}
